import { __assign } from "tslib";
import { PluginType } from '../../domain';
import { createFacebookApi } from './index';
import { createFakePutResponder, createFakeGetResponder, createFakePostResponder, createFakeDeleteResponder } from '../../test-utils';
import { createHttpTestKit } from '../../http/test-kit';
export var createFacebookApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createFacebookApi('', fakeHttp);
    var testKit = {
        whenGoToConnectFacebookPage: function () {
            return window.location.href = "\n\t\t\t\t" + window.location.origin + window.location.pathname + "?code=facebookCode\n\t\t\t";
        },
        whenConnectFacebookPage: function (dto, failResponse) {
            return createFakePostResponder(fakeHttp, "/facebook/pages", failResponse)(dto);
        },
        whenUpdateConnectedFacebookPage: function (dto) {
            return createFakePutResponder(fakeHttp, "/facebook/connections/" + (dto === '*' ? '' : dto.id))(dto);
        },
        whenGetAccountFacebookPages: function (dto) {
            return createFakeGetResponder(fakeHttp, "/facebook/pages?code=" + (dto === '*' ? 'facebookCode' : dto.code) + "&redirectUri=" + window.location.origin + window.location.pathname);
        },
        whenGetConnectedFacebookPages: function (dto) {
            return createFakeGetResponder(fakeHttp, "/facebook/connections?type=" + PluginType.FACEBOOK_PAGE + "&checkTokenStatus=" + (dto === '*' ? '' : !!(dto === null || dto === void 0 ? void 0 : dto.checkTokenStatus)));
        },
        whenRemoveConnectedFacebookPage: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "/facebook/connections/" + (dto === '*' ? '' : dto.id));
        },
        whenGetFacebookTokensStatus: function (dto) {
            if (dto === '*') {
                return createFakeGetResponder(fakeHttp, '/facebook/connections/status');
            }
            var pagesParam = dto.pages ? "pages=" + dto.pages.join(',') : '';
            var onlyInvalidParam = dto.onlyInvalid ? "onlyInvalid=true&" : '';
            var queryParams = (onlyInvalidParam || pagesParam) ? "?" + onlyInvalidParam + pagesParam : '';
            return createFakeGetResponder(fakeHttp, "/facebook/connections/status" + queryParams);
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map